<template>
  <!-- eslint-disable-next-line vue/no-unused-refs -->
  <base-list-management ref="baseListManagement" :configData.sync="configData"/>
</template>
<script>
import diffConfigFn from './config'

export default {
  name: 'maintenance',
  data() {
    const { configData } = diffConfigFn.call(this)
    return {
      configData,
    }
  },
  props: ['customerId', 'customerType'],
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    dealWithData(params) {
      params.customerId = this.customerId
      params.customerType = Number(this.customerType)
    },
  },
}
</script>

